export default __webpack_public_path__ + "static/media/menu-2.8b706fe0.svg";